import React from "react"
import { css } from "@emotion/core"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import TrackedLink from "../components/TrackedLink"

function ContactPage(props) {
  return (
    <Layout>
      <div
        css={css`
          max-width: 640px;
          padding: 0 20px;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 60px;
        `}
      >
        <h1>Contact Us</h1>
        <ul>
          <li>Have a topic that you would like to see covered?</li>
          <li>Have some feedback for our site or an article?</li>
          <li>
            Want to hear our preliminary recommendations for an upcoming guide?
          </li>
          <li>Want specific buying advice for your unique situation?</li>
          <li>Have an idea on how to make the site more helpful for you?</li>
        </ul>
        <p>
          You can always drop us a line at{" "}
          <TrackedLink
            text="hello@satchel.com"
            link="mailto:hello@satchel.com"
          />
        </p>
        <p>
          We'd love to hear from you. <qed />
        </p>
      </div>
    </Layout>
  )
}

export default ContactPage
